import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Specialty } from "../../atoms/Specialty";
import { Specialty as SpecialtyType } from "../../../types/specialty.definition";

interface SpecialtiesProps {
  specialties: SpecialtyType[];
  maxVisible?: number;
  className?: string;
}

export const Specialties: React.FC<SpecialtiesProps> = ({
  specialties,
  maxVisible = 3,
  className = "",
}) => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  if (!specialties || specialties.length === 0) {
    return null;
  }

  const shouldShowToggle = specialties.length > maxVisible;
  const visibleSpecialties = showAll
    ? specialties
    : specialties.slice(0, maxVisible);
  const remainingCount = specialties.length - maxVisible;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {visibleSpecialties.map((specialty, index) => (
        <Specialty key={specialty.id || specialty.code || index} label={specialty.label} />
      ))}
      {shouldShowToggle && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="inline-flex items-center px-3 py-1 text-xs font-medium text-primary-600 hover:text-primary-700 hover:underline transition-colors"
          type="button"
        >
          {showAll
            ? t("common.showLess")
            : `+${remainingCount} ${t("common.more")}...`}
        </button>
      )}
    </div>
  );
};

